export enum Entitlements {
    /**
     * Products
     */
    AddProductFeature = 'Add Product Feature',
    EditProductFeature = 'Edit Product Feature',
    /**
     * Transfers
     */
    CreateTransfer = 'Transfer, Create',
    EditTransfer = 'Edit Transfer',
    DeleteTransfer = 'Delete Transfer',
    ApproveTransfer = 'Approve Transfer',
    CreateTransferTemplate = 'Create Template',
    /**
     * RDC
     */
    RemoteDeposits = 'Remote Deposits',
    /**
     * ACH
     */
    RestrictAchBatch = 'Restricted Batch',
    CreateAchTemplate = 'Create ACH Template',
    FullEditAchTemplate = 'Full Edit Ach Template',
    PartialEditAchTemplate = 'Partial Edit Ach Template',
    DeleteAchTemplate = 'Delete Ach Template',
    ApproveAchTemplate = 'Approve Ach Template',
    CreateAchPayment = 'ACH, Batch, CreatePayment',
    FullEditAchPayment = 'ACH, Payment, Full Edit',
    PartialEditAchPayment = 'ACH, Payment, Partial Edit',
    DeleteAchPayment = 'Delete Ach Payment',
    ApproveAchPayment = 'Approve Ach Payment',
    CreateInternationalAchPayment = 'Create International ACH Payment',
    FullEditInternationalAchPayment = 'Full Edit International ACH Payment',
    PartialEditInternationalAchPayment = 'Partial Edit International ACH Payment',
    DeleteInternationalAchPayment = 'Delete International ACH Payment',
    ApproveInternationalAchPayment = 'Approve International ACH Payment',
    FileUploadEditInternationalAchPayment = 'File Upload Edit International ACH Payment',
    AllowUnbalancedPayments = 'Feature.ACH.AllowUnbalancedPayments',
    /**
     * ACH Exceptions
     */
    WorkAchExceptions = 'Work ACH Exceptions',
    CreateAchFilter = 'Create ACH Filter',
    /**
     * Check Exceptions
     */
    WorkCheckExceptions = 'Work Check Exceptions',
    AllowReturnReason = 'Feature.PositivePay.CheckException.ReturnReason.Default.TM1742',
    HasReturnReason = 'Feature.PositivePay.ReturnReason',
    /**
     * Wires
     */
    CreateDomesticWire = 'Wire, Domestic, Create Wire',
    CreateInternationalWire = 'Wire, International, Create Wire',
    CreateFxWire = 'Wire Transfer DLI, Create Wire',
    CreateDomesticCreditor = 'Wire, Domestic, Create Beneficiary',
    CreateInternationalCreditor = 'Wire, International, Create Beneficiary',
    CreateWireTemplate = 'Wire, Domestic, Create Wire Template',
    WireEditBeneficiary = 'Edit Beneficiary',
    WireApproveBeneficiary = 'Approve Beneficiary',
    CancelWire = 'Cancel Wire',
    EditDomesticWirePayment = 'Edit Domestic Wire Payment',
    DeleteDomesticWirePayment = 'Delete Domestic Wire Payment',
    ApproveDomesticWirePayment = 'Approve DLI Wire Payment',
    EditInternationalWirePayment = 'Edit International Wire Payment',
    DeleteInternationalWirePayment = 'Delete International Wire Payment',
    ApproveInternationalWirePayment = 'Approve International Wire Payment',
    RejectWire = 'Reject Wire',
    HasWirePendingProcessStatus = 'Feature.Wire.Timeout.TM37819',
    WireUpload = 'Upload Domestic Wire File',
    ManageWireFileFormats = 'Manage Wire File Format',
    /**
     * Stop Payments
     */
    AddStopPayment = 'Add Stop Payment',
    ApproveStopPayment = 'Approve Stop Payment',
    CancelStopPayment = 'Cancel Stop Payment',
    /**
     * Bill Pay
     */
    BusinessBillPay = 'Bill Pay',
    /**
     * High-Level Feature Checks
     */
    achEnabled = 'ACH Enabled',
    transfersEnabled = 'Transfers Enabled',
    wiresEnabled = 'Wires Enabled',
    billPayEnabled = 'Bill Pay Enabled',
    remoteDepositsEnabled = 'Remote Deposits Enabled',
    /**
     * Backoffice
     */
    ResetUserPassword = 'Reset User Password',
    EditUserRole = 'Edit User Role',
    /**
     * LD FFs
     */
    InformationCenterModalBannerEnhancement = 'Feature.MessageCenterEnhancement',
    /**
     * FI Users
     */
    EditFiUser = 'Edit FI User',
    ResetFiPassword = 'Reset FI Password',
    DeleteFiUser = 'Delete FI User',
    ChangeFiUserStatus = 'Change FI User Status',
    ChangeFiUserLockedStatus = 'Change FI User Locked Status',
}
